import React from 'react';

import DatePickerCustom from './DatePicker.jsx';
import DropItem from './DropItem.jsx';
import Input from './Input.jsx';
import SelectCustom from './SelectCustom.jsx';
import TextArea from './TextArea.jsx';

const InputControl = (props) => {
  const { controlInput, ...res } = props;
  if (controlInput === 'input') return <Input {...res} />;
  if (controlInput === 'select') return <SelectCustom {...res} />;
  if (controlInput === 'datepicker') return <DatePickerCustom {...res} />;
  if (controlInput === 'textarea') return <TextArea {...res} />;
  if (controlInput === 'dropzone') return <DropItem {...res} />;
};
export default InputControl;
